import { useEffect } from 'react';
import type { ContractTerminationConsequencesResponse } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

type RequestOptions = {
  url: string;
};

export function useContractTerminationConsequences({ url }: HookConfig) {
  const contractTerminationConsequences = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<ContractTerminationConsequencesResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    contractTerminationConsequences.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  return contractTerminationConsequences;
}

export type ContractTerminationConsequencesRequest = ReturnType<
  typeof useContractTerminationConsequences
>;
